import React from "react";
const Marketing = () => {
  return <div>

  </div>;
};

export default Marketing;
